import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { register as registerSwiperElements } from 'swiper/element/bundle';

import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment.dev';

registerSwiperElements();
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

if (environment.PRODUCTION) {
  enableProdMode();
}
